<template>
  <div class="page-container">
		<HeaderLayout :pagecode="pagecode" :subpagecode="cmd" @eventProblemCode="changePage"></HeaderLayout>
		<div class="content">
		      <div class="content-main">
			         <h2>{{info.subject}}</h2>
					 <div class="box-big-card" style='min-height:500px;'>
			         	  <iframe style="width:100%;height:500px" :src="'https://www.youtube.com/embed/'+info.vid" frameborder="0" allow="accelerometer; autoplay;" allowfullscreen></iframe>
			        </div>
					<div class="button-box">
						<md-button class="md-raised md-primary" @click="goList()">목록으로</md-button>	
					</div>
			  </div>
	    </div>
	<FooterLayout></FooterLayout>
	</div>
</template>


<script>
import HeaderLayout from '@/components/inc/Header'
import FooterLayout from '@/components/inc/Footer'

export default {
	name: 'AdvisorView',
	components: {
		HeaderLayout,
		FooterLayout
	},
	data() {
		return {
			pagecode:'advisor',
			cmd:'list',
			info:{},
			no:'',

		}
	},
	created() {
		this.no = this.$route.params.no;
		this.getData();
	},
    methods: {
	   getData() {
		  	var obj = this;
			this.$form.sendPost({no:this.no},'advisor/getDataInfo',function(resp) {
				if(resp.result=='succ') {
					obj.info = resp.info;

				} 
			},'multi');
	  
		},
		goList() {
			this.$router.go(-1);
		},
		changePage(code) {
			switch(code) {
				case 'list':
					this.$router.push({path:'/advisor/list'});
				break;
				case 'sentence':
					this.$router.push({path:'/advisor/sentence'});
				break;
				case 'word':
					this.$router.push({path:'/advisor/word'});
				break;
				case 'problem':
					this.$router.push({path:'/advisor/gtest'});
				break;

			}
		}
	
	}
}
</script>

<style lang="scss" scoped>
*    {
     margin:0;
	 padding:0;
}
a    {
     text-decoration:none;
}
li    {
      list-style:none;
}
.page-container        {
			 width:100%;
	min-height:calc(100vh);
	background:#E6E8F4;
	.content   {
		width:100%;
		padding:180px 0 55px 0; 
		font-family: 'Nanum Gothic', sans-serif;
		.content-main	{
		                  width:830px;
						  margin:0 auto;
						  height:auto;
						  background:#fff;
						  padding:30px;
						  h2 {
							padding:10px 0 20px 0;
						  }
						  .box-big-card     {
						  				  width:100%;
										   border-top:1px solid  #E9E9E9;
										   border-bottom:1px solid  #E9E9E9;
										   padding:30px 0;
										 
										 
						  }
						  .button-box {
								text-align:center;
								.md-button {
									margin:40px auto;
									width:400px;	
								}
						  }
		}
	}		
}
</style>